import retry from '@blockcatio/tabby-library/lib/utilities/retry';
import createPollerMiddleware from '@blockcatio/tabby-library/lib/utilities/poller';

import { accountBalanceUpdate, accountBalanceUpdateFailed } from '../actions/account';
import { APP_SHUTDOWN } from '../actionTypes';

/**
 * Responsible for polling for account balance changes
 */
export default ({ eth }) => (store) => {
  const { dispatch } = store;
  return createPollerMiddleware(store, {
    initialState: { currentBalance: null },
    frequency: 1000,

    checkStart: (action, nextState, prevState) =>
      nextState.account.address !== prevState.account.address,

    checkStop: action => action.type === APP_SHUTDOWN,

    checkRun: (state, reduxState) => reduxState.account.address,

    main: async (pollerState, { account: { address } }) => {
      let { currentBalance } = pollerState;
      try {
        const nextBalance = await retry(() => eth.fetchBalance(address));
        if (!currentBalance || !nextBalance.eq(currentBalance)) {
          dispatch(accountBalanceUpdate(nextBalance));
          currentBalance = nextBalance;
        }
      } catch (error) {
        dispatch(accountBalanceUpdateFailed(error));
      }

      return { currentBalance };
    },
  });
};



// WEBPACK FOOTER //
// ./src/middleware/pollAccountBalance.js